export default __webpack_public_path__ + "static/NeoSansPro-Medium-e231e808b271f46051dc2ea57fc55656.woff2";